import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';
import { Route,Routes } from 'react-router-dom';
import { GenericTitleHeader } from '../component/common/GenericTitleHeader';
// import { DriversTable } from '../component/drivers/DriversTable';
import { DriversTable } from '../component/drivers/DriversTable';
import SectionHeader from "../../../util/component/SectionHeader";
import React from "react";
const DriverPage = () => {
    const { t } = useTranslation(["operation"]);
    return (
        <div>
            <SectionHeader
                title={t("drivers.title")}
            />
            <Routes><Route path="/"  element={<DriversTable/>}/></Routes></div>
           
    );
}

export default DriverPage;